import { setThemeColorByModelName } from "../../constants/ColorsData";
import { CURRENT_COLOR_THEME_USED, BLOCK_VALUE_KEY_LAST_SELECTED } from "../../constants/StoreKey";
import { encryptData, decryptData } from "../../utils/util_function";

export const saveData4Theme = (currentThemeColor: string) => {
    encryptData(CURRENT_COLOR_THEME_USED, currentThemeColor);

    const ls_last_theme_data = decryptData(BLOCK_VALUE_KEY_LAST_SELECTED)
    
    if(ls_last_theme_data) {
        const themeData = typeof(ls_last_theme_data) === 'object' ? ls_last_theme_data : JSON.parse(ls_last_theme_data)
        
        document.documentElement.style.setProperty('--current-theme-color', themeData.color);
        document.documentElement.style.setProperty('--current-theme-color-check', themeData.color);
    }
}